<div class="main-container">
  <div class="top-container">
    <div class="breadcrumb">
      <app-breadcrumb *ngIf="currentFlowKey" [useCaseKey]="'assetManagement'" [flowKey]="currentFlowKey">
      </app-breadcrumb>
    </div>
    <div class="page-header">
      <ng-container *ngIf="selectedCard === 'inventory' || selectedCard === 'inventory-order'">
        <!-- <app-button-group
          [label]="'Procure Items'" [buttonType]="'Secondary'" [cssClass]="'bordered-bg'"
          [buttonUseCase]="'procureItems'" (onEmit)="onProcureItems()">
        </app-button-group> -->
        <app-button-group
          [label]="selectedCard === 'inventory-order' ? 'Bulk Procured Upload' : 'Bulk Issue Upload'" [buttonType]="'Secondary'" [cssClass]="'bordered-bg'"
          [buttonUseCase]="'bulkIssueUpload'" (onEmit)="onBulkIssueUpload()">
        </app-button-group>
      </ng-container>
      <app-button-group
        *ngIf="selectedCard !== 'vendor-stats'"
        [label]="buttonTitle" [buttonType]="selectedCard === 'offboarding' ? 'Secondary' : 'Primary'"
        [buttonUseCase]="buttonTitle" (onEmit)="navigateToDetailView()">
      </app-button-group>
    </div>
  </div>

  <div class="table-actions">
    <app-title-field
      *ngIf="selectedCard !== 'inventory' && selectedCard !== 'inventory-order'"
      [class.damage-analytics-title]="selectedCard === 'damage-analytics'" [title]="pageTitle">
    </app-title-field>
    <div *ngIf="selectedCard === 'inventory' || selectedCard === 'inventory-order'" class="inventory-tabs">
    <button class="inv-tab" [class.active]="selectedCard === 'inventory'"
      (click)="inventoryTabType('inventory')">Accessories Management</button>
    <button class="inv-tab" [class.active]="selectedCard === 'inventory-order'"
      (click)="inventoryTabType('inventory-order')">Orders</button>
  </div>
    <div class="action-buttons">
      <div
        class="dropdown-container"
        *ngIf="
          selectedCard == 'onboarding' ||
          selectedCard == 'offboarding' ||
          selectedCard == 'My-Request'
        "
      >
        <app-dropdown 
          class="emerald-dropdown dropdown-cls employer-dropdown-cls" 
          [options]="employerTypeOptions"
          [label]="'Type'" 
          [displayKey]="'label'" 
          [valueKey]="'value'" 
          [(ngModel)]="selectedEmployerType"
          (dropdownChange)="onEmployerTypeChange($event)"
        >
        </app-dropdown>
      </div>
      <div class="search-field">
        <app-search-field [searchValues]="searchValues" (search)="onSearch($event)" (cleared)="onClear()"
          [placeholder]="selectedCard === 'inventory' ? 'Search by item name or category' : 'Search by name, ID'">
        </app-search-field>
      </div>
      <ng-container
        *ngIf="selectedCard == 'inventory' || selectedCard == 'damage-analytics' || selectedCard == 'inventory-order'">
        <div class="dropdown-container">
          <app-dropdown class="emerald-dropdown dropdown-cls location-dropdown-cls" [options]="locationOptions"
            [label]="'&nbsp;&nbsp;Location'" [displayKey]="'label'" [valueKey]="'value'" [(ngModel)]="selectedLocation"
            (dropdownChange)="handleLocationChange($event)">
          </app-dropdown>
        </div>
      </ng-container>
      <div class="date-range">
        <app-date-range [dateLabel]="dateLabel" [startDatePlaceholder]="startDatePlaceholder"
          [endDatePlaceholder]="endDatePlaceholder" [cardComponent]="selectedCard"
          (dateRangeSelected)="handleDateRangeChange($event)">
        </app-date-range>
      </div>
      <div class="download-button">
        <app-button-group [label]="'Download'" [buttonType]="'Secondary'" [disabled]="selectedRows.length === 0" [cssClass]="'bordered-bg'"
          [buttonUseCase]="'export'" (onEmit)="download()">
        </app-button-group>
      </div>
    </div>
  </div>

  <!-- Accessories Management / Orders tabs -->
  

  <div class="table-container">
    <!-- Card-level loading overlay -->
    <div *ngIf="isCardLoading" class="card-loading-overlay">
      <div class="card-spinner">
        <div class="spinner"></div>
        <span class="loading-text">Loading...</span>
      </div>
    </div>

    <app-table [columnDefs]="columns" [rowData]="rowData" [gridOptions]="gridOptions"
      [enableActions]="tableConfig.enableActions || false" [customActions]="actions"
      [enablePagination]="tableConfig.enablePagination ?? true"
      [paginationPageSize]="tableConfig.paginationPageSize || 10"
      [enableRowSelection]="tableConfig.enableRowSelection || false"
      [rowSelectionMode]="tableConfig.rowSelectionMode || 'multiple'"
      [enableSorting]="tableConfig.enableSorting ?? true" [enableFiltering]="tableConfig.enableFiltering ?? true"
      [enableColumnResize]="tableConfig.enableColumnResize ?? true" [rowClassRules]="tableConfig.rowClassRules || {}"
      (actionClicked)="handleTableAction($event)" (rowSelected)="handleRowSelection($event)"
      (resourceClicked)="handleResourceClick($event)" [frameworkComponents]="frameworkComponents">
    </app-table>
  </div>
</div>